import { Component, Input } from '@angular/core';
import { map, Observable, tap } from 'rxjs';

import { CompatibilityService } from 'src/app/modules/marketing/components/compatibility/services/compatibility.service';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-step-separator',
    templateUrl: './step-separator.component.html',
    styleUrls: ['./step-separator.component.scss'],
    standalone: true,
    imports: [NgClass, AsyncPipe],
})
export class StepSeparatorComponent {
  @Input() step: number = 0;
  @Input() isCurrent: boolean = false;

  isBeforeCurrent: boolean | null = null;
  isBeforeCurrent$: Observable<boolean> =
    this.compatibilityService.currentStep$.pipe(
      map((currentStep) => {
        this.isBeforeCurrent = this.step < currentStep;
        return this.isBeforeCurrent;
      })
    );

  constructor(private compatibilityService: CompatibilityService) {}

  onGoToStep(): void {
    if (this.isBeforeCurrent) {
      this.compatibilityService.goToStep(this.step);
    }
  }
}
